<template>
  <div class="sidebar">
    <ul class="baritems">
      <!-- <router-link to="/super/orgs">
        <li>License Management</li>
      </router-link> -->
      <router-link to="/super/orgs">
        <li>Customer Management</li>
      </router-link>
      <router-link to="/super/users">
        <li>User Management</li>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  props: ['empty']
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/nav.scss";

.text-sm {
  font-size: 0.75rem;
}
</style>
